module.exports = __webpack_public_path__ + "static/media/green-dot.742d7090.gif";